import classNames from 'classnames';
import { Button } from '../../../ui';

import Link from 'next/link';

const Extras = () => {
  const handleScroll = () => {
    const section = document.getElementById('black-offer');
    if (section) {
      section.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <div className="bg-[#F0F0F0] pt-[48px] pb-[73px]">
      <style>{`
        .extras-svg {
          transition: transform 0.3s ease-out;
        }
        .extras-package:hover .extras-svg {
          transform: scale(1.5);
        }
      `}</style>
      <div className="container flex flex-col items-center gap-[48px]">
        <div className="flex flex-col items-center gap-[18px]">
          <p className="md:text-[18px] text-[14px] text-[#000000] font-thin">Extras</p>
          <h2 className="text-center font-[500] text-[32px] md:text-[48px] leading-[39px] md:leading-[59px] text-[#000000]">Power-up your package</h2>
        </div>
        <div className="hide_scrollbar overflow-x-auto overflow-y-hidden w-full" style={{ WebkitOverflowScrolling: 'touch' }}>
          <div className="flex flex-row flex-nowrap gap-[28px] min-w-max">
            <div className="extras-package relative flex flex-col justify-between gap-[16px] shrink-0 p-[16px] bg-white w-[256px] min-h-[305px] transition-shadow duration-200 ease-out hover:shadow-[0_20px_60px_rgba(0,0,0,0.12)]">
              <div className="flex flex-col gap-[16px]">
                <div className="flex flex-row justify-between gap-[10px] border-y border-[#D5D5D5] py-[16px]">
                  <p className="text-[24px] font-[600] text-[#9EBF91] leading-[31px]">
                    Geo <br /> expansion
                  </p>
                  <svg className="extras-svg" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g clipPath="url(#clip0_15601_29813)">
                      <path
                        d="M13.6569 2.34316C12.1458 0.832156 10.1369 0 8 0C5.86312 0 3.85416 0.832156 2.34313 2.34316C0.832125 3.85416 0 5.86312 0 8C0 10.1369 0.832125 12.1459 2.34313 13.6569C3.85413 15.1678 5.86312 16 8 16C10.1369 16 12.1458 15.1678 13.6569 13.6569C15.1678 12.1459 16 10.1369 16 8C16 5.86312 15.1679 3.85416 13.6569 2.34316ZM8.46875 2.71591L10.3584 1.34294C11.7717 1.84516 12.9791 2.78522 13.8168 3.99934L13.1327 6.10453L10.722 6.88784L8.46875 5.25084V2.71591ZM5.64153 1.34297L7.53125 2.71591V5.25091L5.27828 6.88769L2.86741 6.10437L2.18331 3.99922C3.02097 2.78516 4.22831 1.84516 5.64153 1.34297ZM2.54344 12.4789C1.57716 11.3038 0.982219 9.81244 0.939969 8.18584L2.57772 6.99597L4.98844 7.77925L5.84909 10.4282L4.35916 12.4789H2.54344ZM10.3532 14.6589C9.61675 14.9199 8.82478 15.0625 8 15.0625C7.17525 15.0625 6.38328 14.9199 5.64687 14.6589L5.11756 13.0299L6.60747 10.9792L9.39256 10.9791L10.8825 13.0298L10.3532 14.6589ZM13.4566 12.4788H11.6409L10.151 10.4281L11.0117 7.77947L13.4224 6.99616L15.06 8.18597C15.0178 9.81247 14.4228 11.3038 13.4566 12.4788Z"
                        fill="black"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_15601_29813">
                        <rect width="16" height="16" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
                </div>
                <p className="text-[12px] leading-[16px]">
                  Add additional GEOs to scale beyond your base package. Expand into new high-conversion markets across CIS, Europe, LATAM, MENA,
                  Africa, and Asia.
                </p>
              </div>
              <Button variant="blackWorld" onClick={handleScroll}>
                Add Geo
              </Button>
            </div>
            <div className="extras-package relative flex flex-col justify-between gap-[16px] shrink-0 p-[16px] bg-white w-[256px] min-h-[305px] transition-shadow duration-200 ease-out hover:shadow-[0_20px_60px_rgba(0,0,0,0.12)]">
              <div className="flex flex-col gap-[16px]">
                <div className="flex flex-row justify-between gap-[10px] border-y border-[#D5D5D5] py-[16px]">
                  <p className="text-[24px] font-[600] text-[#9EBF91] leading-[31px]">
                    Add <br />
                    Service
                  </p>
                  <svg className="extras-svg" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g clipPath="url(#clip0_15601_29813)">
                      <path
                        d="M13.6569 2.34316C12.1458 0.832156 10.1369 0 8 0C5.86312 0 3.85416 0.832156 2.34313 2.34316C0.832125 3.85416 0 5.86312 0 8C0 10.1369 0.832125 12.1459 2.34313 13.6569C3.85413 15.1678 5.86312 16 8 16C10.1369 16 12.1458 15.1678 13.6569 13.6569C15.1678 12.1459 16 10.1369 16 8C16 5.86312 15.1679 3.85416 13.6569 2.34316ZM8.46875 2.71591L10.3584 1.34294C11.7717 1.84516 12.9791 2.78522 13.8168 3.99934L13.1327 6.10453L10.722 6.88784L8.46875 5.25084V2.71591ZM5.64153 1.34297L7.53125 2.71591V5.25091L5.27828 6.88769L2.86741 6.10437L2.18331 3.99922C3.02097 2.78516 4.22831 1.84516 5.64153 1.34297ZM2.54344 12.4789C1.57716 11.3038 0.982219 9.81244 0.939969 8.18584L2.57772 6.99597L4.98844 7.77925L5.84909 10.4282L4.35916 12.4789H2.54344ZM10.3532 14.6589C9.61675 14.9199 8.82478 15.0625 8 15.0625C7.17525 15.0625 6.38328 14.9199 5.64687 14.6589L5.11756 13.0299L6.60747 10.9792L9.39256 10.9791L10.8825 13.0298L10.3532 14.6589ZM13.4566 12.4788H11.6409L10.151 10.4281L11.0117 7.77947L13.4224 6.99616L15.06 8.18597C15.0178 9.81247 14.4228 11.3038 13.4566 12.4788Z"
                        fill="black"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_15601_29813">
                        <rect width="16" height="16" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
                </div>
                <p className="text-[12px] leading-[16px]">
                  Integrate additional services like PPC, SEO, Sport Ads Network, or premium placements independently. Customize your package based on
                  campaign goals and conversion priorities.
                </p>
              </div>
              <Button variant="blackWorld" onClick={handleScroll}>
                Package upgrade
              </Button>
            </div>
            <div className="extras-package relative flex flex-col justify-between gap-[16px] shrink-0 p-[16px] bg-white w-[256px] min-h-[305px] transition-shadow duration-200 ease-out hover:shadow-[0_20px_60px_rgba(0,0,0,0.12)]">
              <div className="flex flex-col gap-[16px]">
                <div className="flex flex-row justify-between gap-[10px] border-y border-[#D5D5D5] py-[16px]">
                  <p className="text-[24px] font-[600] text-[#9EBF91] leading-[31px]">
                    Infinite <br /> creatives
                  </p>
                  <svg className="extras-svg" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g clipPath="url(#clip0_15601_29813)">
                      <path
                        d="M13.6569 2.34316C12.1458 0.832156 10.1369 0 8 0C5.86312 0 3.85416 0.832156 2.34313 2.34316C0.832125 3.85416 0 5.86312 0 8C0 10.1369 0.832125 12.1459 2.34313 13.6569C3.85413 15.1678 5.86312 16 8 16C10.1369 16 12.1458 15.1678 13.6569 13.6569C15.1678 12.1459 16 10.1369 16 8C16 5.86312 15.1679 3.85416 13.6569 2.34316ZM8.46875 2.71591L10.3584 1.34294C11.7717 1.84516 12.9791 2.78522 13.8168 3.99934L13.1327 6.10453L10.722 6.88784L8.46875 5.25084V2.71591ZM5.64153 1.34297L7.53125 2.71591V5.25091L5.27828 6.88769L2.86741 6.10437L2.18331 3.99922C3.02097 2.78516 4.22831 1.84516 5.64153 1.34297ZM2.54344 12.4789C1.57716 11.3038 0.982219 9.81244 0.939969 8.18584L2.57772 6.99597L4.98844 7.77925L5.84909 10.4282L4.35916 12.4789H2.54344ZM10.3532 14.6589C9.61675 14.9199 8.82478 15.0625 8 15.0625C7.17525 15.0625 6.38328 14.9199 5.64687 14.6589L5.11756 13.0299L6.60747 10.9792L9.39256 10.9791L10.8825 13.0298L10.3532 14.6589ZM13.4566 12.4788H11.6409L10.151 10.4281L11.0117 7.77947L13.4224 6.99616L15.06 8.18597C15.0178 9.81247 14.4228 11.3038 13.4566 12.4788Z"
                        fill="black"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_15601_29813">
                        <rect width="16" height="16" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
                </div>
                <p className="text-[12px] leading-[16px]">
                  Unlock unlimited creative production for full tournament flexibility. Daily match-day creatives, promo banners, event-based
                  campaigns, and continuous creative refresh.
                </p>
              </div>
              <Button variant="blackWorld" onClick={handleScroll}>
                Unlimited Creatives
              </Button>
            </div>
            <div className="extras-package relative flex flex-col justify-between gap-[16px] shrink-0 p-[16px] bg-white w-[256px] min-h-[305px] transition-shadow duration-200 ease-out hover:shadow-[0_20px_60px_rgba(0,0,0,0.12)]">
              <div className="flex flex-col gap-[16px]">
                <div className="flex flex-row justify-between gap-[10px] border-y border-[#D5D5D5] py-[16px]">
                  <p className="text-[24px] font-[600] text-[#9EBF91] leading-[31px]">
                    Advanced <br /> reporting
                  </p>
                  <svg className="extras-svg" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g clipPath="url(#clip0_15601_29813)">
                      <path
                        d="M13.6569 2.34316C12.1458 0.832156 10.1369 0 8 0C5.86312 0 3.85416 0.832156 2.34313 2.34316C0.832125 3.85416 0 5.86312 0 8C0 10.1369 0.832125 12.1459 2.34313 13.6569C3.85413 15.1678 5.86312 16 8 16C10.1369 16 12.1458 15.1678 13.6569 13.6569C15.1678 12.1459 16 10.1369 16 8C16 5.86312 15.1679 3.85416 13.6569 2.34316ZM8.46875 2.71591L10.3584 1.34294C11.7717 1.84516 12.9791 2.78522 13.8168 3.99934L13.1327 6.10453L10.722 6.88784L8.46875 5.25084V2.71591ZM5.64153 1.34297L7.53125 2.71591V5.25091L5.27828 6.88769L2.86741 6.10437L2.18331 3.99922C3.02097 2.78516 4.22831 1.84516 5.64153 1.34297ZM2.54344 12.4789C1.57716 11.3038 0.982219 9.81244 0.939969 8.18584L2.57772 6.99597L4.98844 7.77925L5.84909 10.4282L4.35916 12.4789H2.54344ZM10.3532 14.6589C9.61675 14.9199 8.82478 15.0625 8 15.0625C7.17525 15.0625 6.38328 14.9199 5.64687 14.6589L5.11756 13.0299L6.60747 10.9792L9.39256 10.9791L10.8825 13.0298L10.3532 14.6589ZM13.4566 12.4788H11.6409L10.151 10.4281L11.0117 7.77947L13.4224 6.99616L15.06 8.18597C15.0178 9.81247 14.4228 11.3038 13.4566 12.4788Z"
                        fill="black"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_15601_29813">
                        <rect width="16" height="16" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
                </div>
                <p className="text-[12px] leading-[16px]">
                  Access full cross-channel reporting with personal dashboard visibility. Track CPM, CTR, reach, registrations, and performance by
                  GEO, format, and channel.
                </p>
              </div>
              <Button variant="blackWorld" onClick={handleScroll}>
                Advanced Reports
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Extras;
